export const REQUEST_API_DETAILS = 'REQUEST_API_DETAILS';
export const RECEIVE_API_DETAILS = 'RECEIVE_API_DETAILS';
export const REQUEST_API_EPISODES = 'REQUEST_API_EPISODES';

export const RECEIVE_API_EPISODES = 'RECEIVE_API_EPISODES';
export const REQUEST_API_EPISODE_DETAILS = 'REQUEST_API_EPISODE_DETAILS';
export const RECEIVE_API_EPISODE_DETAILS = 'RECEIVE_API_EPISODE_DETAILS';
